import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default ({ icon, ...props }) =>
  <FontAwesomeIcon icon={icon} {...props} />